import { Reveal } from '../lib/motion';

export default function SectionHead({ n, eyebrow, title, lead, testid, children }) {
  return (
    <div className="grid gap-6 lg:grid-cols-12 lg:gap-10">
      <Reveal className="lg:col-span-3">
        <p className="font-mono-num text-5xl font-bold leading-none tracking-tighter text-[#FF6B00]/90 sm:text-6xl" data-testid={testid ? `${testid}-number` : undefined}>
          {n}
        </p>
        <p className="eyebrow mt-4">{eyebrow}</p>
      </Reveal>
      <div className="lg:col-span-9">
        <Reveal delay={0.08}>
          <h2 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl" data-testid={testid}>
            {title}
          </h2>
        </Reveal>
        {lead && (
          <Reveal delay={0.16}>
            <p className="lead mt-6 max-w-[62ch]">{lead}</p>
          </Reveal>
        )}
        {children}
      </div>
    </div>
  );
}
